export const FETCH_POSTS = 'readerActions/FETCH_POSTS';
export const FETCH_POSTS_SUCCESS = 'readerActions/FETCH_POSTS_SUCCESS';
export const FETCH_POSTS_FAILED = 'readerActions/FETCH_POSTS_FAILURE';

export const CREATE_UPDATE_POST = 'readerActions/CREATE_UPDATE_POST';
export const CREATE_UPDATE_POST_SUCCESS =
  'readerActions/CREATE_UPDATE_POST_SUCCESS';
export const CREATE_UPDATE_POST_FAILED = 'readerActions/FETCH_POST_FAILURE';

export const DELETE_POST = 'readerActions/DELETE_POST';
export const DELETE_POST_SUCCESS = 'readerActions/DELETE_POST_SUCCESS';
export const DELETE_POST_FAILED = 'readerActions/DELETE_POST_FAILURE';

export const FETCH_COMPANIES = 'readerActions/FETCH_COMPANIES';
export const FETCH_COMPANIES_SUCCESS = 'readerActions/FETCH_COMPANIES_SUCCESS';
export const FETCH_COMPANIES_FAILED = 'readerActions/FETCH_COMPANIES_FAILURE';

export const UPDATE_LABEL = 'readerActions/UPDATE_LABEL';
export const UPDATE_LABEL_SUCCESS = 'readerActions/UPDATE_LABEL_SUCCESS';
export const UPDATE_LABEL_FAILED = 'readerActions/UPDATE_LABEL_FAILURE';

export const UPDATE_PROFILE = 'readerActions/UPDATE_PROFILE';
export const UPDATE_PROFILE_SUCCESS = 'readerActions/UPDATE_PROFILE_SUCCESS';
export const UPDATE_PROFILE_FAILED = 'readerActions/UPDATE_PROFILE_FAILURE';
export const UPDATE_STATUS = 'readerActions/UPDATE_STATUS';

export const CHANGE_PASSWORD = 'userActions/CHANGE_PASSWORD';
export const CHANGE_PASSWORD_SUCCESS = 'userActions/CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_FAILED = 'userActions/CHANGE_PASSWORD_FAILED';

export function fetchPosts(filters) {
  return {
    type: FETCH_POSTS,
    filters,
  };
}

export function fetchPostsSuccess(posts, labels) {
  return {
    type: FETCH_POSTS_SUCCESS,
    posts,
    labels,
  };
}

export function fetchPostsFailed(err) {
  return {
    type: FETCH_POSTS_FAILED,
    err,
  };
}

export function createPost(details) {
  return {
    type: CREATE_UPDATE_POST,
    details,
  };
}

export function createPostSuccess() {
  return {
    type: CREATE_UPDATE_POST_SUCCESS,
  };
}

export function createPostFailed(err) {
  return {
    type: CREATE_UPDATE_POST_FAILED,
    err,
  };
}

export function deletePost(_id) {
  return {
    type: DELETE_POST,
    _id,
  };
}

export function deletePostSuccess(_id) {
  return {
    type: DELETE_POST_SUCCESS,
    _id,
  };
}

export function deletePostFailed(err) {
  return {
    type: DELETE_POST_FAILED,
    err,
  };
}

export function fetchCompanies(filters) {
  return {
    type: FETCH_COMPANIES,
    filters,
  };
}

export function fetchCompaniesSuccess(posts, labels) {
  return {
    type: FETCH_COMPANIES_SUCCESS,
    posts,
    labels,
  };
}

export function fetchCompaniesFailed(err) {
  return {
    type: FETCH_COMPANIES_FAILED,
    err,
  };
}

export function updateLabel(details) {
  return {
    type: UPDATE_LABEL,
    details,
  };
}

export function updateLabelSuccess() {
  return {
    type: UPDATE_LABEL_SUCCESS,
  };
}

export function updateLabelFailed(err) {
  return {
    type: UPDATE_LABEL_FAILED,
    err,
  };
}

export function updateProfile(details) {
  return {
    type: UPDATE_PROFILE,
    details,
  };
}

export function updateProfileSuccess(user) {
  return {
    type: UPDATE_PROFILE_SUCCESS,
    user,
  };
}

export function updateProfileFailed(err) {
  return {
    type: UPDATE_PROFILE_FAILED,
    err,
  };
}

export function updateStatus() {
  return {
    type: UPDATE_STATUS,
  };
}

export function changePassword(details) {
  return {
    type: CHANGE_PASSWORD,
    details,
  };
}

export function changePasswordSuccess(user) {
  return {
    type: CHANGE_PASSWORD_SUCCESS,
    user,
  };
}

export function changePasswordFailed(err) {
  return {
    type: CHANGE_PASSWORD_FAILED,
    err,
  };
}
